import React from 'react'
import { baseUrl } from '../../../../../utils';
import ModalData from "./ModalContent";
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

const OptionToExplore = ({ page, openExplorebar, setopenExplorebar }) => {

    return (
        <>
            <div className="explore-rightbar">

                <Button variant='link' type="button" onClick={() => setopenExplorebar(openExplorebar ? '' : 'open-explorebar')} className="explore_toggle_icon p-2" data-factors-form-bind="true" data-factors-click-bind="true">
                    <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={''} />
                </Button>

                <div className="explore-items">
                    <h6 className="text-center px-1">Other Option To Explore </h6>
                    <ul className="list-unstyled mb-0">

                        {ModalData[0].map((curr, index) => {

                            const { name, image, idd, target } = curr;

                            return (

                                page != 3 ?
                                    <li className="explore-item">
                                        <div id={idd} className="explore-card">
                                            <button type="button" className="btn-link p-0 w-100" data-bs-toggle="modal" data-bs-target={target}>
                                                <img src={baseUrl(`explore-options/${image}.png`)} className="img-fluid" width={183} height={120} alt="" />
                                                <hr />
                                                <p className="mb-0">{name}</p>
                                            </button>
                                        </div>
                                    </li> :

                                index != 0 ?
                                    <li className="explore-item">
                                        <div id={idd} className="explore-card">
                                            <button type="button" className="btn-link p-0 w-100" data-bs-toggle="modal" data-bs-target={target}>
                                                <img src={baseUrl(`explore-options/${image}.png`)} className="img-fluid" width={183} height={120} alt="" />
                                                <hr />
                                                <p className="mb-0">{name}</p>
                                            </button>
                                        </div>
                                    </li> : null
                            )

                        })}

                    </ul>
                </div>
            </div>
        </>
    )
}

export default OptionToExplore